<template>
  <v-container>
    <p>Enter your email and you will be sent a password reset link.</p>

    <v-form ref="form" @submit.prevent="onSendRequest">

      <v-alert outlined type="success" :value="!!message">
        {{ message }}
      </v-alert>

      <label>Email Address</label>
      <v-text-field
        v-model="user.email"
        label="Email"
        single-line
        solo
        :rules="validateEmail"
        validate-on-blur
      ></v-text-field>

      <div class="button-group vertical">
        <v-btn
          :disabled="isLoading || !!message"
          class="default-btn blue"
          @click.prevent="onSendRequest"
        >Send request</v-btn>

        <v-btn
          :to="{ name: 'TermsAndConditions' }"
          class="default-btn text subdued"
        >Terms and Conditions</v-btn>
      </div>
    </v-form>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { formMixin } from '@/mixins'

export default {
  name: 'ForgotPasword',
  mixins: [formMixin],
  data: () => ({
    user: {},
    message: '',
    isLoading: false,
  }),
  computed: {
    ...mapGetters('feathers', ['apiPasswordResets']),
  },
  methods: {
    async onSendRequest () {
      if (!this.$refs.form.validate()) return

      this.isLoading = true
      try {
        await this.apiPasswordResets.create(this.user)
        this.message = `Check your ${this.user.email} inbox for instructions from us on how to reset your password.`
      } catch (error) {
        this.addAlert({
          type: 'error',
          message: `There was an error sending your request: ${error.message}`,
        })
      }
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
